



























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import { namespaced, NS_ADMIN } from "../../store/namespace";
import { DELETE_QUESTION } from "../../store/actions.names";
import QuestionForm from "./QuestionForm.vue";

const OPTION = {
  option: { text: "", text_en: "", text_bn: "" },
  correct: false
};

const QUESTION_FORM = {
  options: [OPTION, OPTION, OPTION],
  text: "",
  text_en: "",
  text_bn: "",
  hint: "",
  hint_en: "",
  hint_bn: "",
  image: null,
  type: "radio",
  max_show: 3
};

@Component({
  name: "ExamForm",
  components: {
    QuestionForm
  }
})
export default class ExamForm extends Vue {
  @Action(namespaced(NS_ADMIN, DELETE_QUESTION)) deleteQuestionAction: any;
  @Prop() lang: string;
  @Prop() value: any;
  @Prop() anchor: number;
  internalValue: any = JSON.parse(JSON.stringify(this.value));

  translations: any = {
    autogenerate: {
      en: "Examination Name (keep blank to auto-generate)",
      bn: "পরীক্ষার নাম (অটোজেনারেট করতে ফাঁকা রাখুন)"
    },
    weight: {
      en: "Weight",
      bn: "মূল্যমান"
    },
    qs_show: {
      en: "Questions to Show",
      bn: "দেখানো প্রশ্নের সংখ্যা"
    },
    pp: {
      en: "Pass Percentage",
      bn: "পাস পার্সেন্টেজ"
    }
  };

  addOption(idx) {
    this.internalValue.questions[idx].options.push(
      JSON.parse(JSON.stringify(OPTION))
    );
  }

  // handleQuestionTypeChange(val, idx) {
  //   val = event.target.value;
  //   this.internalValue.questions[idx].type = val;
  //   this.internalValue.questions[idx].correct = val == "radio" ? null : [];
  // }

  // deleteOption(idx, idnx) {
  //   this.internalValue.questions[idx].options.splice(idnx, 1);
  // }

  deleteQuestion(idx) {
    const question = this.internalValue.questions[idx];
    if (question.id) {
      this.deleteQuestionAction({
        exam: question.exam,
        question: question.id
      }).then(resp => {
        this.internalValue.questions.splice(idx, 1);
      });
    } else {
      this.internalValue.questions.splice(idx, 1);
    }
  }

  copyQuestion(idx) {
    var newQ = JSON.parse(JSON.stringify(this.internalValue.questions[idx]));
    newQ.image = null;
    this.internalValue.questions.splice(idx + 1, 0, newQ);
  }

  newQuestion(idx) {
    var newQ = JSON.parse(JSON.stringify(QUESTION_FORM));
    // console.log(newQ);
    newQ.image = null;
    this.internalValue.questions.splice(idx + 1, 0, newQ);
  }

  // handleQuestionImage(e, idx) {
  //   var files = e.target.files || e.dataTransfer.files;
  //   // if (!files.length) return;
  //   this.internalValue.questions[idx].image = files;
  //   // console.log(this.internalValue.files);
  // }

  @Watch("internalValue", { deep: true })
  handleChange(val: any, oldVal: any) {
    val.name = val.name_bn;
    this.$emit("input", val);
  }
}
